
import Vue from 'vue'
import ServiceCard from '../service-card/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'ServiceCardTable',
  components: {
    ServiceCard
  },
  mixins: [staticBlockMixin]
})
